import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { body } from './body.vanilla.mjs';

const ModalBody = forwardRef(
  ({ className: classNameFromProps, ...props }, ref) => {
    const className = classNames(body, classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        "data-scope": "modal",
        "data-part": "body",
        className,
        ref,
        ...props
      }
    );
  }
);
ModalBody.toString = () => '[data-scope="modal"][data-part="body"]';
const StyledDiv = styled(Primitive.div);

export { ModalBody };
//# sourceMappingURL=Body.mjs.map
